import SpineAnimation from './SpineAnimation';
import ISymbolSpineAnimConfig from '../managers/contracts/configurations/ISymbolSpineAnimConfig';
import IAnim from '../managers/contracts/animation/IAnim';
import GameModel from '../model/GameModel';
import ISpineAnimStateConfig from '../managers/contracts/configurations/spine_anim/ISpineAnimStateConfig';

export default class SymbolSpineAnimation extends SpineAnimation implements IAnim<ISymbolSpineAnimConfig> {
    public id: number = null;
    public activeSkin: "";
    public animConfig: ISymbolSpineAnimConfig;
    constructor(animJson: PIXI.spine.core.SkeletonData, name: string, config: ISymbolSpineAnimConfig) {
        super(animJson, name, config);
    }

    public hasChainingAnim = (chainingAnim: string): boolean => {
        return Boolean(this.animConfig.getSkinConfig(this.activeSkin)?.chainingStates?.find(data => data.name === chainingAnim))
    }

    /**
     * name
     */
    public play(
        animState: string = this.animConfig.getSkinConfig(this.activeSkin).defaultState,
        loop: boolean = this.animConfig.getStateConfig(animState).loop,
        timeScale?: number,
    ) {
        super.play(animState, loop, timeScale)
    }

    /**
        name
     */
    public getChainingAnimConfig(chainingAnim: string, skin: string = this.activeSkin) {
        return this.animConfig.getChainingAnimConfig(chainingAnim, skin)
    }

    public getStateConfig(state: string): ISpineAnimStateConfig | undefined {
        return this.animConfig.getStateConfig(state);
    }

    public setActiveSkin = (id: number) => {
        let skin = GameModel.gameConfig.symbolAssetsMap[id].name;
        if (this.activeSkin !== skin) {
            this.skeleton.setSkinByName(skin);
            this.activeSkin = skin;
            this.id = id;
        }
    }
}
